import { useSuspenseQuery } from '@connectrpc/connect-query'
import { useTranslation } from 'react-i18next'

import { getCompanyAllowedMailDomains } from '~/gen/proto/bff/v1/common-BffCommonService_connectquery'
import { CompanyAllowedMailDomain } from '~/gen/proto/bff/v1/model_pb'

export function useGetCompanyAllowedMailDomains(
  companyId: string,
): CompanyAllowedMailDomain {
  const { t } = useTranslation()

  const res = useSuspenseQuery(
    getCompanyAllowedMailDomains,
    { companyId },
    {
      select: (data) => data.allowedMailDomain,
    },
  )
  if (res.isError || res.data === undefined) {
    throw new Error(t('message.fetchFail', { entity: t('domain.company') }))
  }
  return res.data
}
